
import {Component} from '@angular/core';
import {EmIconModule} from '@em/shared/ui';
import {IHeaderGroupAngularComp} from 'ag-grid-angular';
import {IHeaderGroupParams} from 'ag-grid-community';

@Component({
  selector: 'em-custom-header-group',
  imports: [EmIconModule],
  templateUrl: './custom-header-group.component.html',
  styles: [],
})
export class CustomHeaderGroupComponent implements IHeaderGroupAngularComp {
  params!: IHeaderGroupParams & {logo?: string; icon?: string};
  expandState!: string;

  agInit(params: IHeaderGroupParams): void {
    this.params = params;
  }
}
